import { render, staticRenderFns } from "./ApplicantOtherIncome.vue?vue&type=template&id=4ff575b4&scoped=true&"
import script from "./ApplicantOtherIncome.vue?vue&type=script&lang=js&"
export * from "./ApplicantOtherIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff575b4",
  null
  
)

export default component.exports